import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_search_disable_provision.svg'


const _withScopeId = n => (_pushScopeId("data-v-b7522fd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-nav" }
const _hoisted_2 = { class: "search_contents_wrapper" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"\" data-v-b7522fd4><div class=\"search_title\" data-v-b7522fd4> 求人検索のご利用には <br data-v-b7522fd4><span class=\"search_title_clause\" data-v-b7522fd4>利用規約の確認と</span><span class=\"search_title_clause\" data-v-b7522fd4>キャリアシートの更新が必要です</span></div><div class=\"search_text\" data-v-b7522fd4> 最後の情報更新から一定期間過ぎた場合は <br data-v-b7522fd4> 情報の更新をお願いしています </div>", 3)
const _hoisted_6 = { class: "search_layout_button" }
const _hoisted_7 = { class: "search_button" }

import { useRouter } from 'vue-router';
import BaseButton from '@/components/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchDisableExpired',
  setup(__props) {

const router = useRouter();

const transitionPage = () => {
  router.push({ name: 'e10' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BaseButton, {
            onClick: transitionPage,
            theme: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("利用規約とキャリアシートの確認へ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})